const libPictView = require('pict-view');

const ENTITY_LABELS = (
	{
		Contract: 'Contract specification sets',
		LineItem: 'Line item pay items',
		ProjectLineItemMaterialTest: 'Sample plan tests',
		MaterialLineItemJoin: 'Line item materials',
	});

const LOAD_STATUS_LABELS = (
	{
		'Loaded': 'Saved',
		'Errors': 'Some failed',
		'Not attempted': 'Skipped (an earlier step failed)',
	});

class LIMSSamplePlanCopy extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.comprehensionResult = null;
		this.loadResult = null;
		this.statusMessage = '';
		this.isProcessing = false;

		this._selectedSource = null;
		this._selectedDest = null;

		this.sourceSets = null;
		this.destSets = null;
		this.projectSetsDiffer = false;
		this.specSetView = null;

		this.flipTargetSpecificationSet = false;
	}

	/**
	 * @return {string} What the copy does about differing specification sets, given the checkbox.
	 */
	get setMismatchOutcome()
	{
		if (this.flipTargetSpecificationSet)
		{
			return 'The copy will also move the destination\'s contract and line item pay items onto the source\'s specification sets.';
		}
		return 'The destination keeps its specification sets; sample plan tests are copied onto its line items by item code.';
	}

	/**
	 * Record whether the copy also moves the destination onto the source's specification sets. A preview built
	 * with the other choice no longer matches, so it is cleared.
	 * @param {boolean} pChecked - The checkbox state.
	 */
	async setFlipTargetSpecificationSet(pChecked)
	{
		this.flipTargetSpecificationSet = pChecked === true;
		this.saveSelections();
		if (this.comprehensionResult)
		{
			this.comprehensionResult = null;
			this.loadResult = null;
			this.specSetView = null;
			this.pict.views.HeadlightPanels.toast({ message: 'Preview again to see the copy with this choice.', type: 'is-info' });
		}
		await this.rerender();
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
		super.onBeforeRenderAsync(pCallback, pRenderable);
	}

	onAfterRender(pRenderable)
	{
		this.initializeSelect2Plugin({
			placeholder: 'Search for a source project...',
			ElementID: 'SamplePlanCopy-SourceProject',
			ParentID: 'SamplePlanCopy-SourceProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: ['Name'],
			PageSize: 50,
		});
		this.initializeSelect2Plugin({
			placeholder: 'Search for a destination project...',
			ElementID: 'SamplePlanCopy-DestProject',
			ParentID: 'SamplePlanCopy-DestProjectParent',
			URL: 'Projects',
			IDField: 'IDProject',
			TextField: ['Name'],
			PageSize: 50,
		});

		$('#SamplePlanCopy-SourceProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Source');
			});
		$('#SamplePlanCopy-DestProject').on('select2:select',
			() =>
			{
				this.onProjectSelected('Dest');
			});

		// Restore previously selected values after rerender
		if (this._selectedSource)
		{
			let tmpOption = new Option(this._selectedSource.text, this._selectedSource.id, true, true);
			$('#SamplePlanCopy-SourceProject').append(tmpOption).trigger('change');
		}
		if (this._selectedDest)
		{
			let tmpOption = new Option(this._selectedDest.text, this._selectedDest.id, true, true);
			$('#SamplePlanCopy-DestProject').append(tmpOption).trigger('change');
		}

		return super.onAfterRender(pRenderable);
	}

	/**
	 * Initializes a Select2 Selector via jQuery for project search.
	 * @param {object} pOptions - The select customization options.
	 */
	initializeSelect2Plugin(pOptions)
	{
		$('#' + pOptions.ElementID).select2({
			dropdownParent: $('#' + pOptions.ParentID),
			dropdownCssClass: pOptions.dropdownCssClass || 'theme-light',
			/* @ts-ignore */
			selectionCssClass: pOptions.selectionCssClass || 'theme-light',
			placeholder: pOptions.placeholder || 'Select...',
			minimumInputLength: 0,
			language: {
				searching: function()
				{
					return 'Searching...';
				},
				noResults: function()
				{
					return 'No projects found.';
				},
				loadingMore: function()
				{
					return 'Loading more results...';
				},
				inputTooShort: function(args)
				{
					return 'Type to search for a project...';
				},
			},
			ajax: {
				xhrFields: {
					withCredentials: true,
				},
				dataType: 'json',
				method: 'GET',
				url: function(params)
				{
					const tmpSearchQuery = {
						filters: [
							{
								field: 'Deleted',
								comparator: 'EQ',
								target: '0',
							},
						],
						pagination: {
							start: 1,
							limit: pOptions.PageSize || 50,
						},
						sort: {
							field: 'Name',
							direction: 'ASC',
						},
					};
					if (params.term)
					{
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FOP',
						});
						tmpSearchQuery.filters.push({
							field: 'Name',
							comparator: 'LK',
							target: params.term,
						});
						tmpSearchQuery.filters.push({
							field: '',
							target: '',
							comparator: 'FCP',
						});
					}
					const startCount = (tmpSearchQuery.pagination.start - 1) * tmpSearchQuery.pagination.limit;
					const endCount = tmpSearchQuery.pagination.start * tmpSearchQuery.pagination.limit;
					return `/1.0/${pOptions.URL}/${_Pict.providers.UtilityProvider.generateMeadowFilter(tmpSearchQuery)}/${startCount}/${endCount}`;
				},
				processResults: function(data, params)
				{
					params.page = params.page || 1;
					return {
						results: _Pict.providers.UtilityProvider.formatSelect2Results(data, pOptions.IDField, pOptions.TextField, [], null, true),
					};
				},
			},
		});
	}

	/**
	 * Save the current select2 selections so they can be restored after rerender.
	 */
	saveSelections()
	{
		let tmpSourceEl = $('#SamplePlanCopy-SourceProject');
		let tmpDestEl = $('#SamplePlanCopy-DestProject');

		let tmpSourceData = tmpSourceEl.select2('data');
		if (tmpSourceData && tmpSourceData.length > 0)
		{
			this._selectedSource = { id: tmpSourceData[0].id, text: tmpSourceData[0].text };
		}

		let tmpDestData = tmpDestEl.select2('data');
		if (tmpDestData && tmpDestData.length > 0)
		{
			this._selectedDest = { id: tmpDestData[0].id, text: tmpDestData[0].text };
		}
	}

	/**
	 * Look up the specification sets of a newly selected project and show them under its picker.
	 * @param {string} pSide - 'Source' or 'Dest'.
	 */
	onProjectSelected(pSide)
	{
		let tmpElementID = (pSide === 'Source') ? '#SamplePlanCopy-SourceProject' : '#SamplePlanCopy-DestProject';
		let tmpIDProject = parseInt($(tmpElementID).val(), 10);
		if (isNaN(tmpIDProject))
		{
			return;
		}

		let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
		tmpService.describeProjectSpecificationSets(tmpIDProject, null,
			(pError, pSets) =>
			{
				if (parseInt($(tmpElementID).val(), 10) !== tmpIDProject)
				{
					return;
				}

				let tmpDisplay = null;
				if (pError)
				{
					this.log.error(`Error describing specification sets for project ${tmpIDProject}`, pError);
					this.pict.views.HeadlightPanels.toast({ message: 'Could not read the specification sets for that project.', type: 'is-warning' });
				}
				else
				{
					tmpDisplay = this.formatProjectSets(pSets, pSets.SpecificationSetNames);
				}

				if (pSide === 'Source')
				{
					this.sourceSets = tmpDisplay;
				}
				else
				{
					this.destSets = tmpDisplay;
				}
				this.projectSetsDiffer = this.isSpecificationSetMismatch(this.sourceSets, this.destSets);
				this.saveSelections();
				this.rerender();
			});
	}

	/**
	 * @param {number} pIDTestSpecificationSet - A set ID.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {string} A display label.
	 */
	formatSetLabel(pIDTestSpecificationSet, pNames)
	{
		if (!(pIDTestSpecificationSet > 0))
		{
			return 'None';
		}
		return (pNames || {})[pIDTestSpecificationSet] || `Specification set ${pIDTestSpecificationSet}`;
	}

	/**
	 * @param {Record<string, any>} pSets - A ProjectSpecificationSets from SamplePlanService.
	 * @param {Record<string, string>} pNames - Set names by ID.
	 * @return {Record<string, any>} Display fields for one project.
	 */
	formatProjectSets(pSets, pNames)
	{
		let tmpBasisLabel = 'Unknown: no contract, and the line items do not share one specification set';
		if (pSets.Basis === 'Contract')
		{
			tmpBasisLabel = `Its contract, ${pSets.Contract.Name || pSets.Contract.IDContract}`;
		}
		else if (pSets.Basis === 'PayItems')
		{
			tmpBasisLabel = 'Its line items\' pay items (no contract)';
		}
		return (
			{
				Known: pSets.ItemIDTestSpecificationSet > 0,
				ItemIDTestSpecificationSet: pSets.ItemIDTestSpecificationSet,
				MaterialIDTestSpecificationSet: pSets.MaterialIDTestSpecificationSet,
				PayItemSetIDs: Object.keys(pSets.PayItemSetDistribution || {}).map((pID) => parseInt(pID, 10)),
				ItemLabel: this.formatSetLabel(pSets.ItemIDTestSpecificationSet, pNames),
				MaterialLabel: this.formatSetLabel(pSets.MaterialIDTestSpecificationSet, pNames),
				BasisLabel: tmpBasisLabel,
			});
	}

	/**
	 * @param {Record<string, any>|null} pSource - Source display sets.
	 * @param {Record<string, any>|null} pDest - Destination display sets.
	 * @return {boolean} True when a copy between them would realign the destination.
	 */
	isSpecificationSetMismatch(pSource, pDest)
	{
		if (!pSource || !pDest || !pSource.Known)
		{
			return false;
		}
		if (pDest.Known && ((pSource.ItemIDTestSpecificationSet !== pDest.ItemIDTestSpecificationSet) || (pSource.MaterialIDTestSpecificationSet !== pDest.MaterialIDTestSpecificationSet)))
		{
			return true;
		}
		return pDest.PayItemSetIDs.some((pID) => pID !== pSource.ItemIDTestSpecificationSet);
	}

	/**
	 * Flatten the service's specification set report into template-ready fields.
	 * @param {Record<string, any>} pSpecSets - reportData.specificationSets from SamplePlanService.
	 * @return {Record<string, any>|null} Display fields, or null when the report carries none.
	 */
	prepareSpecificationSetView(pSpecSets)
	{
		if (!pSpecSets || !pSpecSets.Alignment)
		{
			return null;
		}
		let tmpNames = pSpecSets.Names || {};
		let tmpAlignment = pSpecSets.Alignment;
		let tmpSource = this.formatProjectSets(pSpecSets.Source, tmpNames);
		let tmpDest = this.formatProjectSets(pSpecSets.Dest, tmpNames);
		let tmpContract = tmpAlignment.Contract;
		let tmpShared = tmpContract ? tmpContract.SharedWithProjects : [];
		return (
			{
				Crossing: tmpAlignment.Crossing === true,
				ShowChanges: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip !== false),
				ShowKept: (tmpAlignment.Crossing === true) && (tmpAlignment.Flip === false),
				SourceItemLabel: tmpSource.ItemLabel,
				SourceMaterialLabel: tmpSource.MaterialLabel,
				SourceBasisLabel: tmpSource.BasisLabel,
				DestItemLabel: tmpDest.ItemLabel,
				DestMaterialLabel: tmpDest.MaterialLabel,
				DestBasisLabel: tmpDest.BasisLabel,
				TargetItemLabel: this.formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
				HasContractUpdate: !!tmpContract,
				NoContract: (tmpAlignment.Crossing === true) && !pSpecSets.Dest.Contract,
				ContractLabel: tmpContract ? `${tmpContract.Name || 'Contract'} [${tmpContract.IDContract}]` : '',
				ContractItemBefore: tmpContract ? this.formatSetLabel(tmpContract.Before.ItemIDTestSpecificationSet, tmpNames) : '',
				ContractItemAfter: tmpContract ? this.formatSetLabel(tmpContract.After.ItemIDTestSpecificationSet, tmpNames) : '',
				ContractMaterialBefore: tmpContract ? this.formatSetLabel(tmpContract.Before.MaterialIDTestSpecificationSet, tmpNames) : '',
				ContractMaterialAfter: tmpContract ? this.formatSetLabel(tmpContract.After.MaterialIDTestSpecificationSet, tmpNames) : '',
				ContractShared: tmpShared.length > 0,
				SharedProjectCount: tmpShared.length,
				SharedProjects: tmpShared.map((pProject) => ({ Value: `${pProject.Name || '(unnamed)'} [${pProject.IDProject}]` })),
				RemapCount: tmpAlignment.LineItemRemaps.length,
				Remaps: tmpAlignment.LineItemRemaps.map((pRemap) => (
					{
						ItemCode: pRemap.ItemCode,
						Name: pRemap.Name,
						From: this.formatSetLabel(pRemap.FromIDTestSpecificationSet, tmpNames),
						To: this.formatSetLabel(tmpAlignment.ItemIDTestSpecificationSet, tmpNames),
					})),
				HasUnmapped: tmpAlignment.Unmapped.length > 0,
				UnmappedCount: tmpAlignment.Unmapped.length,
				Unmapped: tmpAlignment.Unmapped,
			});
	}

	async buildComprehension()
	{
		let tmpSourceID = parseInt($('#SamplePlanCopy-SourceProject').val(), 10);
		let tmpDestID = parseInt($('#SamplePlanCopy-DestProject').val(), 10);

		if (isNaN(tmpSourceID) || isNaN(tmpDestID))
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Please select both a source and destination project.', type: 'is-warning' });
			return;
		}

		if (tmpSourceID === tmpDestID)
		{
			this.pict.views.HeadlightPanels.toast({ message: 'Source and destination projects must be different.', type: 'is-warning' });
			return;
		}

		this.saveSelections();
		this.isProcessing = true;
		this.comprehensionResult = null;
		this.loadResult = null;
		this.specSetView = null;
		this.statusMessage = 'Preparing the preview... This may take a moment for large projects.';
		await this.rerender();

		try
		{
			let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.comprehensionResult = await new Promise((resolve, reject) =>
			{
				tmpService.buildComprehension(tmpSourceID, tmpDestID, { FlipTargetSpecificationSet: this.flipTargetSpecificationSet },
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			// Ensure warnings are plain strings for template rendering
			if (this.comprehensionResult && this.comprehensionResult.warnings)
			{
				this.comprehensionResult.warnings = this.comprehensionResult.warnings.map(
					(pWarning) => (typeof pWarning === 'string') ? { Value: pWarning } : pWarning
				);
			}

			this.specSetView = this.prepareSpecificationSetView(this.comprehensionResult.reportData.specificationSets);

			this.statusMessage = '';
			this.pict.views.HeadlightPanels.toast({ message: 'Preview ready.', type: 'is-success' });
		}
		catch (pError)
		{
			this.log.error('Error building comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not prepare the preview. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	exportComprehension()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		let tmpJSON = JSON.stringify(this.comprehensionResult.comprehension, null, 2);
		let tmpBlob = new Blob([tmpJSON], { type: 'application/json' });
		let tmpURL = URL.createObjectURL(tmpBlob);

		let tmpSourceName = this.comprehensionResult.reportData.sourceProject.Name || this.comprehensionResult.reportData.sourceProject.IDProject;
		let tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;

		let tmpLink = document.createElement('a');
		tmpLink.href = tmpURL;
		tmpLink.download = `Comprehension-MaterialsSamplePlan_From_${tmpSourceName}_To_${tmpDestName}.json`;
		document.body.appendChild(tmpLink);
		tmpLink.click();
		document.body.removeChild(tmpLink);
		URL.revokeObjectURL(tmpURL);
	}

	confirmLoadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		let tmpStats = this.comprehensionResult.reportData.stats;
		let tmpDestName = this.comprehensionResult.reportData.destProject.Name || this.comprehensionResult.reportData.destProject.IDProject;
		let tmpSpecSetView = this.specSetView;
		let tmpSharedContract = !!(tmpSpecSetView && tmpSpecSetView.ContractShared);

		let fRenderRows = (pRows) => pRows.map((pRow) => /*html*/`
						<tr>
							<td>${pRow.Label}</td>
							<td class="has-text-right"><strong>${pRow.Count}</strong></td>
						</tr>`)
			.join('');
		let tmpChangeRows = fRenderRows([
			{ Label: ENTITY_LABELS.Contract, Count: tmpStats.contractUpdateCount || 0 },
			{ Label: ENTITY_LABELS.LineItem, Count: tmpStats.lineItemRemapCount || 0 },
			{ Label: ENTITY_LABELS.ProjectLineItemMaterialTest, Count: tmpStats.plimtCount },
			{ Label: ENTITY_LABELS.MaterialLineItemJoin, Count: tmpStats.mljCount },
		].filter((pRow, pIndex) => (pIndex > 1) || (pRow.Count > 0)));
		let tmpUnchangedRows = fRenderRows([
			{ Label: 'Sample plan tests in the source', Count: tmpStats.sourcePlimtCount || 0 },
			{ Label: 'Source tests not copied (item code not on the destination)', Count: tmpStats.unmappedSourcePlimtCount || 0 },
			{ Label: 'Repeated source tests, copied once', Count: tmpStats.collapsedPlimtCount || 0 },
			{ Label: 'Sample plan tests already on the destination (kept)', Count: tmpStats.destExistingPlimtCount || 0 },
			{ Label: 'Line item materials already on the destination (kept)', Count: tmpStats.destExistingMljCount || 0 },
		]);

		let tmpSpecSetNotices = '';
		if (tmpSpecSetView && tmpSpecSetView.ShowKept)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-info is-soft mb-3">
					<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
				</div>`;
		}
		if (tmpSpecSetView && tmpSpecSetView.ShowChanges)
		{
			let tmpContractChange = '';
			if (tmpSpecSetView.HasContractUpdate)
			{
				tmpContractChange = ` Contract ${tmpSpecSetView.ContractLabel} moves to <strong>${tmpSpecSetView.ContractItemAfter}</strong> (item) and <strong>${tmpSpecSetView.ContractMaterialAfter}</strong> (material).`;
			}
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>This copy crosses specification sets.</strong> The destination's line items move onto <strong>${tmpSpecSetView.TargetItemLabel}</strong> pay items.${tmpContractChange}
				</div>`;
		}
		if (tmpSharedContract)
		{
			tmpSpecSetNotices += /*html*/`
				<div class="notification is-danger is-soft mb-3">
					<p><strong>Shared contract.</strong> ${tmpSpecSetView.ContractLabel} is also used by ${tmpSpecSetView.SharedProjectCount} other project(s). Their specification sets change too, while their line items stay on their current pay items:</p>
					<ul>${tmpSpecSetView.SharedProjects.map((pProject) => `<li>${pProject.Value}</li>`).join('')}</ul>
				</div>`;
		}

		this.fable.HeadlightModal.spawnModal({
			title: 'Confirm Sample Plan Copy',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5 has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-warning"></i>
					</span>
					<span> Copy the sample plan to the destination?</span>
				</p>
				${tmpSpecSetNotices}
				<p class="is-6 has-text-centered mb-3">This will add or update the following in <strong>${tmpDestName}</strong>:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:400px;">
					<tbody>${tmpChangeRows}
					</tbody>
				</table>
				<p class="is-6 has-text-centered mb-3">The copy does not remove anything:</p>
				<table class="table is-fullwidth is-narrow mx-auto" style="max-width:520px;">
					<tbody>${tmpUnchangedRows}
					</tbody>
				</table>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-soft" type="button" title="Cancel" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button ${tmpSharedContract ? 'is-danger' : 'is-success'}" type="button" title="Copy to Destination" onclick="_Pict.views.LIMSSamplePlanCopy.loadToDestination()">
					<span class="icon">
						<i class="fas fa-fw fa-upload" aria-hidden="true"></i>
					</span>
					<span>Copy to Destination</span>
				</button>
			</div>`,
			confirmText: 'Copy to Destination',
			cancelText: 'Cancel',
		});
	}

	async loadToDestination()
	{
		if (!this.comprehensionResult || !this.comprehensionResult.comprehension)
		{
			return;
		}

		this.fable.HeadlightModal.dismissModals();

		this.saveSelections();
		this.isProcessing = true;
		this.loadResult = null;
		this.statusMessage = 'Copying the sample plan to the destination project...';
		await this.rerender();

		try
		{
			let tmpService = this.pict.instantiateServiceProviderWithoutRegistration('SamplePlanService');
			this.loadResult = await new Promise((resolve, reject) =>
			{
				tmpService.loadComprehension(this.comprehensionResult.comprehension,
					(pError, pResult) =>
					{
						if (pError)
						{
							reject(pError);
						}
						else
						{
							resolve(pResult);
						}
					});
			});

			this.loadResult.entities = this.loadResult.entities.map((pEntity) => Object.assign({}, pEntity,
				{
					Label: ENTITY_LABELS[pEntity.Entity] || pEntity.Entity,
					StatusLabel: LOAD_STATUS_LABELS[pEntity.Status] || pEntity.Status,
				}));

			this.statusMessage = '';
			if (this.loadResult.entities.some((pEntity) => pEntity.Failed > 0))
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied, but some changes failed. See Copy Results.', type: 'is-warning' });
			}
			else
			{
				this.pict.views.HeadlightPanels.toast({ message: 'Sample plan copied.', type: 'is-success' });
			}
		}
		catch (pError)
		{
			this.log.error('Error loading comprehension', pError);
			this.statusMessage = `Error: ${pError.message || pError}`;
			this.pict.views.HeadlightPanels.toast({ message: 'Could not copy the sample plan. Check the console for details.', type: 'is-danger' });
		}

		this.isProcessing = false;
		await this.rerender();
	}

	/**
	 * Re-render the view, preserving select2 selections.
	 */
	async rerender()
	{
		return await new Promise((resolve) =>
		{
			this.renderAsync(() =>
			{
				resolve();
			});
		});
	}
}

module.exports = LIMSSamplePlanCopy;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'LIMSSamplePlanCopy',
		DefaultRenderable: 'LIMSSamplePlanCopy',
		DefaultDestinationAddress: '#LIMS-Application-Container',

		AutoRender: true,

		CSS: '',

		Templates: [
			{
				Hash: 'LIMSSamplePlanCopy-Wrapper',
				Template: /*html*/`
				<section id="LIMSSamplePlanCopy" class="form p-5">
					<h2 class="title is-4 mb-3">Copy Sample Plan</h2>
					<div class="content">
						<div class="box">
							<div class="columns">
								<div class="column">
									<div class="field">
										<label class="label">Source Project (Master Sample Plan)</label>
										<div class="control" id="SamplePlanCopy-SourceProjectParent">
											<select id="SamplePlanCopy-SourceProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project containing the sample plan to copy from.</p>
										{~TIfAbs:LIMSSamplePlanCopy-ProjectSets:Context[0].sourceSets:Context[0].sourceSets^!=^null~}
									</div>
								</div>
								<div class="column">
									<div class="field">
										<label class="label">Destination Project</label>
										<div class="control" id="SamplePlanCopy-DestProjectParent">
											<select id="SamplePlanCopy-DestProject" style="width:100%">
											</select>
										</div>
										<p class="help">The project to copy the sample plan into.</p>
										{~TIfAbs:LIMSSamplePlanCopy-ProjectSets:Context[0].destSets:Context[0].destSets^!=^null~}
									</div>
								</div>
							</div>
							<div class="field">
								<label class="checkbox">
									<input
										type="checkbox"
										id="SamplePlanCopy-FlipTargetSpecificationSet"
										onchange="_Pict.views.LIMSSamplePlanCopy.setFlipTargetSpecificationSet(this.checked)"
										{~TIfAbs:LIMSSamplePlanCopy-Checked:Record:Context[0].flipTargetSpecificationSet^TRUE^x~}
										{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									/>
									Also move the destination onto the source's specification sets
								</label>
								<p class="help">Changes the destination contract's specification sets and switches its line items to the source set's pay items. Leave this off to keep the destination on its current specification sets; sample plan tests are copied by item code either way.</p>
							</div>
							<div class="field">
								<div class="control">
									<button
										type="button"
										class="button is-info"
										onclick="_Pict.views.LIMSSamplePlanCopy.buildComprehension()"
										{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
									>
										<span class="icon mr-2">
											<i class="fas fa-fw fa-copy"></i>
										</span>
										Preview Copy
									</button>
								</div>
							</div>
						</div>
						{~TIfAbs:LIMSSamplePlanCopy-SetMismatch:Record:Context[0].projectSetsDiffer^TRUE^x~}
						{~T:LIMSSamplePlanCopy-Status:Record~}
						{~T:LIMSSamplePlanCopy-Results:Record~}
						{~T:LIMSSamplePlanCopy-LoadResults:Record~}
					</div>
				</section>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Disabled',
				Template: 'disabled',
			},
			{
				Hash: 'LIMSSamplePlanCopy-Checked',
				Template: 'checked',
			},
			{
				Hash: 'LIMSSamplePlanCopy-Status',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-StatusMessage:Record:Context[0].statusMessage.length^>^0~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-StatusMessage',
				Template: /*html*/`
				<div class="notification is-info is-soft">
					<span class="icon mr-2">
						<i class="fas fa-spinner fa-spin"></i>
					</span>
					{~D:Context[0].statusMessage~}
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Results',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-ResultsContent:Record:Context[0].comprehensionResult^!=^null~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-ResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Preview</h3>
					{~TIfAbs:LIMSSamplePlanCopy-Warnings:Record:Context[0].comprehensionResult.warnings.length^>^0~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSets:Record:Context[0].specSetView^!=^null~}
					<div class="columns">
						<div class="column">
							<table class="table is-fullwidth is-striped">
								<thead>
									<tr>
										<th>Metric</th>
										<th class="has-text-right">Count</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Source Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourceLineItemCount~}</td>
									</tr>
									<tr>
										<td>Destination Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destLineItemCount~}</td>
									</tr>
									<tr>
										<td>Matched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.matched~}</td>
									</tr>
									<tr>
										<td>Unmatched Line Items</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmatched~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.plimtCount~}</td>
									</tr>
									<tr>
										<td>Line Item Materials to Copy</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.mljCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests in the Source</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.sourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Source Tests Not Copied (item code not on the destination)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.unmappedSourcePlimtCount~}</td>
									</tr>
									<tr>
										<td>Sample Plan Tests Already on the Destination (kept)</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.destExistingPlimtCount~}</td>
									</tr>
									{~TIfAbs:LIMSSamplePlanCopy-RealignmentStatRows:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
								</tbody>
							</table>
						</div>
						<div class="column">
							<div class="field mb-2">
								<strong>Source Project:</strong> {~D:Context[0].comprehensionResult.reportData.sourceProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.sourceProject.IDProject~}</span>
							</div>
							<div class="field mb-4">
								<strong>Destination Project:</strong> {~D:Context[0].comprehensionResult.reportData.destProject.Name~}
								<span class="tag ml-2">ID: {~D:Context[0].comprehensionResult.reportData.destProject.IDProject~}</span>
							</div>
							<div class="field mb-2">
								<em>Generated: {~D:Context[0].comprehensionResult.reportData.generatedDate~}</em>
							</div>
						</div>
					</div>
					<div class="buttons">
						<button
							type="button"
							class="button is-link"
							onclick="_Pict.views.LIMSSamplePlanCopy.exportComprehension()"
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-download"></i>
							</span>
							Download Preview (JSON)
						</button>
						<button
							type="button"
							class="button is-success"
							onclick="_Pict.views.LIMSSamplePlanCopy.confirmLoadToDestination()"
							{~TIfAbs:LIMSSamplePlanCopy-Disabled:Record:Context[0].isProcessing^TRUE^x~}
						>
							<span class="icon mr-2">
								<i class="fas fa-fw fa-upload"></i>
							</span>
							Copy to Destination
						</button>
					</div>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-Warnings',
				Template: /*html*/`
				<div class="notification is-warning is-soft mb-3">
					<strong>Warnings:</strong>
					<ul>
						{~TS:LIMSSamplePlanCopy-WarningItem:Context[0].comprehensionResult.warnings~}
					</ul>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-WarningItem',
				Template: /*html*/`<li>{~D:Record.Value~}</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResults',
				Template: /*html*/`
					{~TIfAbs:LIMSSamplePlanCopy-LoadResultsContent:Record:Context[0].loadResult^!=^null~}
				`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResultsContent',
				Template: /*html*/`
				<div class="box">
					<h3 class="title is-5 mb-3">Copy Results</h3>
					<table class="table is-fullwidth is-striped">
						<thead>
							<tr>
								<th>Change</th>
								<th class="has-text-right">Records</th>
								<th class="has-text-right">Saved</th>
								<th class="has-text-right">Failed</th>
								<th>Status</th>
							</tr>
						</thead>
						<tbody>
							{~TS:LIMSSamplePlanCopy-LoadResultRow:Context[0].loadResult.entities~}
						</tbody>
					</table>
				</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-LoadResultRow',
				Template: /*html*/`
							<tr>
								<td>{~D:Record.Label~}</td>
								<td class="has-text-right">{~D:Record.Sent~}</td>
								<td class="has-text-right">{~D:Record.Succeeded~}</td>
								<td class="has-text-right">{~D:Record.Failed~}</td>
								<td>{~D:Record.StatusLabel~}</td>
							</tr>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-ProjectSets',
				Template: /*html*/`
					<div class="tags mt-2 mb-0">
						<span class="tag is-info">Item set: {~D:Record.ItemLabel~}</span>
						<span class="tag">Material set: {~D:Record.MaterialLabel~}</span>
					</div>
					<p class="help mt-0">Based on: {~D:Record.BasisLabel~}</p>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SetMismatch',
				Template: /*html*/`
					<div class="notification is-warning is-soft">
						<span class="icon mr-2">
							<i class="fas fa-fw fa-exclamation-triangle"></i>
						</span>
						<strong>These projects use different specification sets.</strong>
						Source: {~D:Context[0].sourceSets.ItemLabel~} (item), {~D:Context[0].sourceSets.MaterialLabel~} (material).
						Destination: {~D:Context[0].destSets.ItemLabel~} (item), {~D:Context[0].destSets.MaterialLabel~} (material).
						{~D:Context[0].setMismatchOutcome~}
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSets',
				Template: /*html*/`
					<table class="table is-fullwidth is-narrow mb-3">
						<thead>
							<tr>
								<th>Specification Sets</th>
								<th>Item</th>
								<th>Material</th>
								<th>Based On</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Source</td>
								<td>{~D:Context[0].specSetView.SourceItemLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.SourceBasisLabel~}</td>
							</tr>
							<tr>
								<td>Destination</td>
								<td>{~D:Context[0].specSetView.DestItemLabel~}</td>
								<td>{~D:Context[0].specSetView.DestMaterialLabel~}</td>
								<td>{~D:Context[0].specSetView.DestBasisLabel~}</td>
							</tr>
						</tbody>
					</table>
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetCrossing:Record:Context[0].specSetView.ShowChanges^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetKept:Record:Context[0].specSetView.ShowKept^TRUE^x~}`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetKept',
				Template: /*html*/`
					<div class="notification is-info is-soft mb-3">
						<strong>The destination keeps its specification sets.</strong> Its contract and line item pay items are not changed; sample plan tests are copied onto its line items by item code.
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetCrossing',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<p class="mb-2"><strong>This copy crosses specification sets.</strong> Copying also updates the destination to match the source:</p>
						<ul>
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetContractChange:Record:Context[0].specSetView.HasContractUpdate^TRUE^x~}
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetNoContract:Record:Context[0].specSetView.NoContract^TRUE^x~}
							{~TIfAbs:LIMSSamplePlanCopy-SpecSetLineItemChange:Record:Context[0].specSetView.RemapCount^>^0~}
						</ul>
					</div>
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetShared:Record:Context[0].specSetView.ContractShared^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetUnmapped:Record:Context[0].specSetView.HasUnmapped^TRUE^x~}
					{~TIfAbs:LIMSSamplePlanCopy-SpecSetRemaps:Record:Context[0].specSetView.RemapCount^>^0~}`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetContractChange',
				Template: /*html*/`
							<li>
								<strong>Contract</strong> {~D:Context[0].specSetView.ContractLabel~}:
								item set {~D:Context[0].specSetView.ContractItemBefore~} &rarr; {~D:Context[0].specSetView.ContractItemAfter~},
								material set {~D:Context[0].specSetView.ContractMaterialBefore~} &rarr; {~D:Context[0].specSetView.ContractMaterialAfter~}
							</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetNoContract',
				Template: /*html*/`<li><strong>Contract</strong>: the destination has no contract, so only its line items change.</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetLineItemChange',
				Template: /*html*/`<li><strong>Line items</strong>: {~D:Context[0].specSetView.RemapCount~} line item(s) switch to the pay item with the same item code in {~D:Context[0].specSetView.TargetItemLabel~}.</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetShared',
				Template: /*html*/`
					<div class="notification is-danger is-soft mb-3">
						<strong>Shared contract.</strong> {~D:Context[0].specSetView.ContractLabel~} is also used by {~D:Context[0].specSetView.SharedProjectCount~} other project(s). Their specification sets change too, while their line items stay on their current pay items:
						<ul>
							{~TS:LIMSSamplePlanCopy-WarningItem:Context[0].specSetView.SharedProjects~}
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetUnmapped',
				Template: /*html*/`
					<div class="notification is-warning is-soft mb-3">
						<strong>{~D:Context[0].specSetView.UnmappedCount~} line item(s) keep their current pay item</strong> because {~D:Context[0].specSetView.TargetItemLabel~} has no single pay item with the same item code:
						<ul>
							{~TS:LIMSSamplePlanCopy-UnmappedItem:Context[0].specSetView.Unmapped~}
						</ul>
					</div>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-UnmappedItem',
				Template: /*html*/`<li>{~D:Record.ItemCode~} {~D:Record.Name~}: {~D:Record.Reason~}</li>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-SpecSetRemaps',
				Template: /*html*/`
					<details class="mb-3">
						<summary>Line item pay item changes ({~D:Context[0].specSetView.RemapCount~})</summary>
						<div style="max-height:320px; overflow-y:auto;">
							<table class="table is-fullwidth is-narrow is-striped">
								<thead>
									<tr>
										<th>Item Code</th>
										<th>Line Item</th>
										<th>Current Pay Item Set</th>
										<th>New Pay Item Set</th>
									</tr>
								</thead>
								<tbody>
									{~TS:LIMSSamplePlanCopy-RemapRow:Context[0].specSetView.Remaps~}
								</tbody>
							</table>
						</div>
					</details>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-RemapRow',
				Template: /*html*/`
									<tr>
										<td>{~D:Record.ItemCode~}</td>
										<td>{~D:Record.Name~}</td>
										<td>{~D:Record.From~}</td>
										<td>{~D:Record.To~}</td>
									</tr>`,
			},
			{
				Hash: 'LIMSSamplePlanCopy-RealignmentStatRows',
				Template: /*html*/`
									<tr>
										<td>Contract Specification Set Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.contractUpdateCount~}</td>
									</tr>
									<tr>
										<td>Line Item Pay Item Changes</td>
										<td class="has-text-right">{~D:Context[0].comprehensionResult.reportData.stats.lineItemRemapCount~}</td>
									</tr>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'LIMSSamplePlanCopy',
				TemplateHash: 'LIMSSamplePlanCopy-Wrapper',
				RenderMethod: 'replace',
			},
		],
	});
